import { render, staticRenderFns } from "./FrameLinks.vue?vue&type=template&id=a9db69e8&scoped=true"
import script from "./FrameLinks.vue?vue&type=script&lang=js"
export * from "./FrameLinks.vue?vue&type=script&lang=js"
import style0 from "./FrameLinks.vue?vue&type=style&index=0&id=a9db69e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9db69e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9db69e8')) {
      api.createRecord('a9db69e8', component.options)
    } else {
      api.reload('a9db69e8', component.options)
    }
    module.hot.accept("./FrameLinks.vue?vue&type=template&id=a9db69e8&scoped=true", function () {
      api.rerender('a9db69e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/editor/FrameLinks.vue"
export default component.exports